import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import { useFeatures } from './features';
import _ from 'lodash';
import {connectLocation} from "../../location/LocationConnectors";
import Text from '../../OC/oc-text';

const featureFlags = css`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .feature-flag {
    height: 50px;
    width: auto;

    &:nth-child(2) {
      margin-left: 5px;
    }
  }
`;

const FlagWithText = styled.div`
  background: #d40f7d;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    color: white !important;
    margin: auto 0.4em;
    text-transform: uppercase;
  }
`

const FeatureSubImage = ({ t, item, feature = {} }) => {
  const { key: featureKey, flagStyle = {} } = feature
  const translateScoped = (key) => {
    const translation = t(`shingles.features.${featureKey}.${key}`)
    return translation?.startsWith('MISSING: ') ? null : translation
  }

  // preference is translated icon > translated text > feature.flagIcon > feature.icon
  let flagIcon = translateScoped('flag_icon')
  let flagText = translateScoped('flag_text')
  let flagAlt = translateScoped('alt')

  const attrs = feature.itemAttributes(item);
  if (attrs) {
    flagIcon = attrs.flagIcon
    flagAlt = attrs.flagAlt
  } else if (!flagText) { // only continue looking for flagIcon if we didn't get a text
    flagIcon ||= feature.flagIcon
    flagIcon ||= feature.icon
    flagAlt ||= feature.alt
  }

  if (flagIcon) {
    return <img alt={flagAlt} className="feature-flag" style={flagStyle} src={flagIcon} />
  } else {
    return (
      <FlagWithText style={flagStyle}>
        <Text content={flagText} />
      </FlagWithText>
    )
  }
}

export const FeatureImage = connectLocation(({ t, item, featuresSubset = [], address, ...props }) => {
  const allRoofingFeatures = useFeatures();

  if (!allRoofingFeatures) {
    return null;
  }

  let shingleFeatures = [];
  let consideredFeatures = allRoofingFeatures;

  if (!_.isEmpty(featuresSubset)) {
    consideredFeatures = _.filter(consideredFeatures, f => featuresSubset.includes(f.key))
  }

  for (const feature of consideredFeatures) {
    if (feature.shouldShowFlag(item)) {
      shingleFeatures.unshift(feature);
    }
  }

  return (
    <div {...props} css={featureFlags}>
      {shingleFeatures.map((f, idx) => <FeatureSubImage item={item} key={idx} t={t} feature={f} />)}
    </div>
  );

})
